module.exports = __webpack_public_path__ + "static/paystack-api-keys-34dae2b16917c5d42cda5a7d54114f50.png";